import { render, staticRenderFns } from "./BoardManagement.vue?vue&type=template&id=64c04649&"
import script from "./BoardManagement.vue?vue&type=script&lang=js&"
export * from "./BoardManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports